export default "__VITE_ASSET__BCzyYx$o__"